import { create } from "zustand";
import { ErrorLog, ErrorLogItem } from "../types/errors.interface";
import { devtools } from "zustand/middleware";

interface ErrorState {
  errorReport: ErrorLog;
  errors: ErrorLogItem[];
  setUserEmail: (email: string | null) => void;
  addError: (error: ErrorLogItem) => void;
  clearErrors: () => void;
}

export const useErrorStore = create<ErrorState>()(
  devtools((set) => ({
    errors: [],
    errorReport: {
      user_email: null,
      timestamp: new Date().toISOString(),
      report_url: window.location.href,
      errors: [],
    },
    setUserEmail: (email: string | null) =>
      set((state) => ({
        ...state,
        errorReport: { ...state.errorReport, user_email: email },
      })),
    addError: async (error) =>
      set((state) => ({
        errorReport: {
          ...state.errorReport,
          errors: [...state.errorReport.errors, error],
        },
      })),
    clearErrors: () =>
      set((state) => ({
        ...state,
        errorReport: { ...state.errorReport, errors: [] },
      })),
  }))
);
